module.exports = __webpack_public_path__ + "static/media/finisher-icon.f1562aa7.png";